import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Input, FormCustom, Select, TextArea } from '../../Components/Form/Form';
import Controllers from '../../Api/Controllers';
import ReactPlaceholder from 'react-placeholder/lib';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify';

const SupplierRequestForm = ({ data, onSubmit, disableSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id: data.id || '',
        p_supplier_id: data.supplier_id || '',
        p_amount: data.amount || '',
        p_request_description: data.request_description || '',
        p_request_date: data.request_date || '',
        // p_cost_center_id: data.cost_center_id || '',
        p_file_path: data.file_path || '',
        p_status: data.status || 'PENDING',
        p_id_company: data.id_company || '',
    });

    const [ready, setReady] = useState(false);
    const [suppliers, setSuppliers] = useState([]);
    const [costCenters, setCostCenters] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [costCenterDetails, setCostCenterDetails] = useState([]);

    useEffect(() => {
        // Cargar los proveedores y centros de costos
        Promise.all([
            Controllers.supplier.get_supplier(),
            Controllers.supplier_request.getCompaniesActive()
        ]).then(res => {
            setSuppliers(res[0].data);
            setCompanies(res[1].data);
            return Controllers.cost_center.get_cost_center();
        }).then(res => {
            setCostCenters(res.data);
            setReady(true);
        }).catch(err => console.error(err));
    }, []);

    useEffect(() => {
        if (data.id && Array.isArray(data.cost_centers)) {
            const prefilled = data.cost_centers.map(cc => ({
                id: cc.id,
                amount: cc.amount
            }));
            setCostCenterDetails(prefilled);
        }
    }, [data]);

    // Selección de Proveedor
    const selectedSupplier = useMemo(() => {
        if (!row.p_supplier_id) return;
        const finded = suppliers.find(s => parseInt(row.p_supplier_id) === parseInt(s.supplier_id));
        if (!finded) return;
        return { label: finded.supplier_name, value: finded.supplier_id };
    }, [row.p_supplier_id, suppliers]);

    // Selección de Centro de Costo
    /* const selectedCostCenter = useMemo(() => {
        if (!row.p_cost_center_id) return;
        const finded = costCenters.find(cc => parseInt(row.p_cost_center_id) === parseInt(cc.id));
        if (!finded) return;
        return { label: finded.cost_center_name, value: finded.id };
    }, [row.p_cost_center_id, costCenters]); */

    const dataSubmit = useCallback(() => {
        let formData = new FormData()

        for (const key in row) {
            if (key === 'p_file_path') {
                if (row.p_file_path?.files) {
                    if (row.p_file_path.files.length > 0) {
                        formData.append('p_file_path', row.p_file_path.files[0])
                        continue
                    }
                }
                formData.append('p_file_path', '')
                continue
            }
            formData.append(key, row[key])
        }

        return formData
    }, [row])

    const idCompany = useMemo(() => {
        if (!row.p_id_company) {
            return
        }

        let finded = companies.find(t => parseInt(row.p_id_company) === parseInt(t.id_company))

        if (!finded) {
            return
        }
        return {
            label: finded.name_company,
            value: finded.id_company
        }
    }, [row.p_id_company, companies])


    return (
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
            <FormCustom viewSubmit={row.p_status === 'PENDING'} dataSubmit={dataSubmit()} onSubmit={({ data }) => {
                const total = costCenterDetails.reduce((acc, cc) => acc + parseFloat(cc.amount || 0), 0);
                const amount = parseFloat(row.p_amount);

                if (!row.p_id_company) {
                    Helpers.toast.construct({ response: 'warning', message: 'Seleccionar Empresa', toast });
                    return;
                }

                if (!row.p_supplier_id) {
                    Helpers.toast.construct({ response: 'warning', message: 'Seleccionar Proveedor', toast });
                    return;
                }

                if (costCenterDetails.length === 0) {
                    Helpers.toast.construct({ response: 'warning', message: 'Seleccionar al menos un centro de costo', toast });
                    return;
                }

                if (total !== amount) {
                    Helpers.toast.construct({ response: 'warning', message: `La suma de los montos por centro de costo (${total}) debe ser igual al monto total (${amount})`, toast });
                    return;
                }

                // Puedes agregar los centros de costo como JSON dentro del FormData si deseas
                data.append('p_cost_center_details', JSON.stringify(costCenterDetails));

                onSubmit({ data });
            }} disableSubmit={disableSubmit} loadSubmit={loadSubmit}>
                {row.p_status === 'REJECTED' && <div className='col-12 mb-2'>
                    Motivo Rechazo: {data.rejection_reason}
                </div>}
                <Select
                    classNameParent="col-12 mb-2"
                    icon="fas fa-user-tie"
                    text="Empresa"
                    options={companies.map(t => {
                        return {
                            label: t.name_company,
                            value: t.id_company
                        }
                    })}
                    value={idCompany}
                    onChange={e => setRow({ ...row, p_id_company: e.value })}
                    disabled={row.p_status !== 'PENDING'}
                />
                <Select
                    classNameParent="col-12 mb-2"
                    icon="fas fa-building"
                    text="Proveedor"
                    options={suppliers.map(s => ({
                        label: s.supplier_name,
                        value: s.supplier_id
                    }))}
                    value={selectedSupplier}
                    onChange={e => setRow({ ...row, p_supplier_id: e.value })}
                    required
                    disabled={row.p_status !== 'PENDING'}
                />
                <Input
                    text="Monto de la Orden"
                    placeholder="Monto de la Orden"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-dollar-sign"
                    required
                    invalid="El monto es obligatorio."
                    defaultValue={row.p_amount}
                    onChange={e => setRow({ ...row, p_amount: e.currentTarget.value })}
                    maxLength={20}
                    disabled={row.p_status !== 'PENDING'}
                />
                <TextArea
                    text="Descripción de la Orden"
                    placeholder="Descripción de la Orden"
                    classNameParent="col-12 mb-2"
                    icon="far fa-comment"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={row.p_request_description}
                    onChange={e => setRow({ ...row, p_request_description: e.currentTarget.value })}
                    maxLength={255}
                    rows={5}
                    disabled={row.p_status !== 'PENDING'}
                />
                <Input
                    text="Fecha de Orden"
                    type="date"
                    classNameParent="col-12 mb-2"
                    icon="fa fa-calendar-alt"
                    required
                    invalid="La fecha es obligatoria."
                    defaultValue={row.p_request_date}
                    onChange={e => setRow({ ...row, p_request_date: e.currentTarget.value })}
                    disabled={row.p_status !== 'PENDING'}
                />
                <Select
                    classNameParent="col-12 mb-2"
                    icon="fas fa-sitemap"
                    text="Centros de Costo"
                    options={costCenters.map(cc => ({
                        label: cc.cost_center_name,
                        value: cc.id
                    }))}
                    value={costCenterDetails.map(cc => ({
                        label: costCenters.find(c => c.id === cc.id)?.cost_center_name || '',
                        value: cc.id
                    }))}
                    isMulti={true}
                    onChange={selected => {
                        if (selected?.length > 0) {
                            const updated = selected.map(sel => {
                                const existing = costCenterDetails.find(cc => cc.id === sel.value);
                                return existing || { id: sel.value, amount: '' };
                            });
                            setCostCenterDetails(updated);
                        } else {
                            setCostCenterDetails([]);
                        }
                    }}
                    disabled={row.p_status !== 'PENDING'}
                />
                {costCenterDetails.map((cc, idx) => (
                    <div key={cc.id} className="col-12 mb-4 d-flex align-items-center gap-2">
                        <span className="w-50">{costCenters.find(c => c.id === cc.id)?.cost_center_name}</span>
                        <Input
                            text=""
                            placeholder="Monto"
                            type="number"
                            min="0.01"
                            step="0.01"
                            classNameParent="w-50"
                            value={cc.amount}
                            onChange={e => {
                                const value = e.currentTarget.value;
                                const updated = [...costCenterDetails];
                                updated[idx].amount = value;
                                setCostCenterDetails(updated);
                            }}
                            required
                            disabled={row.p_status !== 'PENDING'}
                        />
                    </div>
                ))}
                {/* <Select
                    classNameParent="col-12 mb-2"
                    icon="fas fa-sitemap"
                    text="Centro de Costo"
                    options={costCenters.map(cc => ({
                        label: cc.cost_center_name,
                        value: cc.id
                    }))}
                    value={selectedCostCenter}
                    onChange={e => setRow({ ...row, p_cost_center_id: e.value })}
                    required
                    disabled={row.p_status !== 'PENDING'}
                /> */}
                <Input
                    icon="fa fa-image"
                    type="file"
                    text="Archivo Adjunto *"
                    classNameParent="col-12 mb-2"
                    accept="image/png, image/jpeg, application/pdf"
                    required={!data.file_path}
                    onChange={e => setRow({ ...row, p_file_path: e.currentTarget })}
                    disabled={row.p_status !== 'PENDING'}
                />
                {data.file_path ? (
                    <div className="col-12">
                        <a href={Helpers.config.resourcesUrl({ url: data.file_path })} target="_blank" rel="noopener noreferrer">
                            {/* <img src={Helpers.config.resourcesUrl({ url: data.file_path })} width="300" alt="Archivo adjunto" className="img-thumbnail" /> */}
                            Ver File
                        </a>
                    </div>
                ) : ''}
            </FormCustom>
        </ReactPlaceholder>
    );
};

SupplierRequestForm.defaultProps = {
    data: {
        id: '',
        supplier_id: '',
        amount: '',
        request_description: '',
        request_date: '',
        cost_center_id: '',
        status: 'PENDING',
        file_path: '',
    },
    onSubmit: () => { },
    loadSubmit: false
};

export default SupplierRequestForm;
